module.exports = "<div class=\"rating\" ng-if=\"!$ctrl.isReadOnly\">\n    <span ng-repeat=\"renderObj in $ctrl.icons track by $index\"\n          ng-click=\"$ctrl.returnIndex($index)\"\n          class=\"rating__item\">\n        <i ng-class=\"renderObj\"\n           class=\"rating__item__icon\"></i>\n    </span>\n</div>\n<div class=\"rating--styled\" ng-if=\"$ctrl.isReadOnly\">\n    <span ng-repeat=\"renderObj in $ctrl.icons track by $index\">\n        <i ng-class=\"renderObj\"></i>\n    </span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./~/@front10/healthcare-book/src/app/common/rating/rating.html
// module id = 587
// module chunks = 0